module.exports = function () {
  return new Worker(__webpack_public_path__ + "257753050d52b36216f5.worker.js");
};